<template>
    <div>
        <el-form :inline="true" :model="formFinish" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item label="用户ID">
                <el-input v-model="formFinish.customerId" placeholder="用户ID"></el-input>
            </el-form-item>
            <el-form-item label="任务ID">
                <el-input v-model="formFinish.taskId" placeholder="任务ID"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="success" @click="handleFinishTask">完成任务</el-button>
                <el-button type="success" @click="handleAdd">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="taskList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading" >
          <!--  <el-table-column type="selection" width="55"></el-table-column>-->
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="level" label="等级" width="60"></el-table-column>
            <el-table-column prop="id" label="任务ID" width="140"></el-table-column>
            <el-table-column prop="taskName" label="任务名称" width="260"></el-table-column>
            <el-table-column label="任务类型">
                <template  slot-scope="scope">
                    <div v-if="scope.row.taskType==1">活动类</div>
                    <div v-else-if="scope.row.taskType==2">下单类</div>
                    <div v-else-if="scope.row.taskType==3">储值类</div>
                </template>
            </el-table-column>
            <el-table-column prop="rewardData" label="任务数据"></el-table-column>
            <el-table-column prop="taskOrdernum" label="任务排序"></el-table-column>
            <el-table-column label="状态">
                <template  slot-scope="scope">
                    <div v-if="scope.row.status==0">禁用</div>
                    <div v-else-if="scope.row.status==1">启用</div>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="500">
                <template slot-scope="scope">
                    <selectPicComponents :selectImages="{'proId':scope.row.id,'picType':201,'proName':scope.row.level,'limitCount':1,'btnText':'弹窗图'}"></selectPicComponents>
                    <el-button type="primary" size="mini" @click="handleEdit(scope.row)">修改</el-button>
                    <el-button type="warning " size="mini" @click="handleDel(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="添加会员任务" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="120px">
                <el-form-item label="等级" >
                    <el-select v-model="form.level" clearable  placeholder="等级">
                        <el-option
                                v-for="item in conditionList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="任务名称">
                    <el-input v-model="form.taskName" placeholder="任务名称"></el-input>
                </el-form-item>
                <el-form-item label="任务类型" >
                    <el-select v-model="form.taskType" clearable  placeholder="任务类型">
                        <el-option label="活动类" value="1"></el-option>
                        <el-option label="下单类" value="2"></el-option>
                        <el-option label="储值类" value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="任务数据">
                    <el-input v-model="form.taskData" placeholder="任务数据"></el-input>
                </el-form-item>
                <el-form-item label="弹窗跳转URL">
                    <el-input v-model="form.taskDirectUrl" placeholder="弹窗跳转URL"></el-input>
                </el-form-item>
                <el-form-item label="状态" >
                    <el-select v-model="form.status" clearable  placeholder="状态">
                        <el-option label="启用" value="1"></el-option>
                        <el-option label="禁用" value="0"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addTask(form)">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {taskList,saveTask,delTask,getOptionConditionList,finishTask} from '../../api/api'
    import selectPicComponents from '@/components/selectPic';
    //定义组件
    export default{
        data(){
            return {
                conditionList:[],
                taskList:[],
                loading:true,
                selectValue: '',
                dialogFormVisible:false,
                form:{
                    "id" : "",
                    "level":"",
                    "taskName":"",
                    "taskType":"",
                    "taskData":"",
                    "taskDirectUrl":"",
                    "status":""
                },
                formInline:{
                    currentPage:1,
                    recordsTotal:0,
                    pageSize:10,
                },
                formFinish:{
                    customerId:'',
                    taskId:''
                }
            }
        },
        components:{
            selectPicComponents
        },
        //挂载时候执行
        mounted(){
            //获取会员等级下拉
            getOptionConditionList({}).then((res) => {
                this.conditionList = res.data.value;
            })
            //初始化首页数据
            this.getList();
        },
        methods:{
            //定义查询方法
            getList(){
                this.loading = true;
                taskList(this.formInline).then((res) => {
                    this.loading = false;
                    this.taskList = res.data.list;
                    this.formInline.recordsTotal = res.data.total;
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList();
            },
            handleEdit(row){
                this.form.id = row.id;
                this.form.level = row.level;
                this.form.taskName = row.taskName;
                this.form.taskType = row.taskType;
                this.form.taskData = row.taskData;
                this.form.taskDirectUrl = row.taskDirectUrl;
                this.form.status = row.status;
                this.dialogFormVisible = true;
            },
            handleDel(row){
                this.$confirm('删除等级, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delTask({id:row.id}).then((res) => {
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList(this.currentPage,this.pageSize);
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {

                });
            },
            handleAdd(){
                this.form={}
                this.dialogFormVisible = true;
            },
            addTask(form){
                saveTask(form).then((res) => {
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.dialogFormVisible = false;
                        this.getList(this.currentPage,this.pageSize);
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleFinishTask(){
                finishTask(this.formFinish).then((res) => {
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/vip/vipTask.vue